// extracted by mini-css-extract-plugin
export var closeButton = "_c5-1";
export var closeX = "_c5-3";
export var container = "_c5-0";
export var image = "_c5-2";